import React, { useState } from "react";
import DashboardHeader from "@/components/DashboardHeader";
import DashboardLayout from "@/layouts/DashboardLayout";
import { SubmitHandler, useForm } from "react-hook-form";
import { FormHookInput, Loader, Button, passwordValidator } from "@thdinc/hpf-shared";

import { useNavigate } from "react-router";
import { POST } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import { useAppSelector } from "@/hooks/hook";

import useLoading from "@/hooks/useLoading";
import ChangesAlert from "@/components/alert/ChangesAlert";
import { updateAccessToken,updateRefreshToken } from "@/redux/slices/userSlice";
import { useDispatch } from "react-redux";

type Inputs = {
    oldPassword: string;
    password: string;
    confirmPassword: string;
};
const ChangePassword = () => {
    const { changePassword } = API_ROUTES;
    const { refreshToken } = useAppSelector((store) => store.user);
    const { isLoading, startLoading, stopLoading } = useLoading();
    const dispatch = useDispatch();

    const {
        register,
        handleSubmit,

        watch,

        formState: { errors },
    } = useForm<Inputs>();


    const navigate = useNavigate();
    // to listen a change
    const password = watch("password");



    const [modal, setModal] = useState<boolean>(false)
    const [activeData, setActiveData] = useState<any | null>(null)
    const [currentError, setCurrentError] = useState("")
    const [newError, setNewError] = useState("")
    const [confirmError, setConfirmError] = useState("")



    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        // reset the error messages and set the active data
        setConfirmError("")
        setNewError("")
        setCurrentError("")
        const body = {
            newPassword: data.password,
            oldPassword: data.oldPassword,
            confirmPassword: data.confirmPassword
        }
        // state update for modal confirmation
        setActiveData(body)
        setModal(true)
    };


    const saveDetails = async () => {
        setModal(false)
        startLoading()
        try {
            const response = await POST(changePassword, activeData, refreshToken);
            if (response.data.success) {
                dispatch(updateAccessToken({ accessToken: response?.data?.accessToken }))
                dispatch(updateRefreshToken({ refreshToken: response?.data?.refreshToken }))
                // navigate to dashboard page if successful
                navigate("/");
            } else {
                // throughs errors if any
                setCurrentError(response?.data?.currentPassword)
                setNewError(response?.data?.newPassword)
                setConfirmError(response?.data?.confirmPassword)
            }
        } catch (error) {
            setConfirmError("")
            setNewError("")
            setCurrentError("")
        } finally {
            stopLoading();
        }
    }

    return (
        <div>
            <DashboardHeader title={"Password"} />
            <div className="mx-auto bg-white rounded-2xl shadow-md border p-6">
                <div className="lg:block lg:w-fit w-full flex justify-center flex-col items-center ">
                    <div className="flex items-center" >
                        <p className="text-2xl font-semibold">Change Password</p>
                    </div>
                    <p className="text-gray-700 mt-2">
                        You can update your password here.
                    </p>
                </div>

                <div className="flex flex-col lg:flex-row justify-between items-start mt-4">

                    <form
                        className="grid gap-x-4 gap-y-1 md:grid-cols-2 grid-cols-1 lg:w-11/12 w-full"
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <div className="">
                            <div className=" font-semibold my-2">Current Password *</div>

                            <FormHookInput
                                type="password"
                                placeholder="Current Password"
                                register={register("oldPassword", {
                                    required: "Current Password is required",
                                    // pattern: passwordValidator
                                })}
                                error={errors.oldPassword}
                            />
                            {
                                currentError &&
                                <p className="mt-1 text-xs text-red-500" >{currentError}</p>
                            }
                        </div>
                        <div className="">
                            <div className=" font-semibold my-2">New Password *</div>
                            <FormHookInput
                                type="password"
                                placeholder="Password"
                                register={register("password", {
                                    required: "New Password is required",
                                    pattern: passwordValidator,
                                })}
                                error={errors.password}
                            />
                            {
                                newError &&
                                <p className="mt-1 text-xs text-red-500" >{newError}</p>
                            }
                        </div>
                        <div className="">
                            <div className=" font-semibold my-2">Confirm Password *</div>
                            <FormHookInput
                                type="password"
                                placeholder="Confirm Password"
                                register={register("confirmPassword", {
                                    validate: (value) =>
                                        value === password || "The passwords do not match!",
                                    required: "Confirm Password is required",
                                    // pattern: passwordValidator
                                })}
                                error={errors.confirmPassword}
                            />
                            {
                                confirmError &&
                                <p className="mt-1 text-xs text-red-500" >{confirmError}</p>
                            }
                        </div>

                        <div>
                            <div className="flex justify-end mt-8">
                                <Button
                                    type="submit"
                                    classes={"bg-primary-red text-white hover:bg-primary-red-button-hover"}
                                    disabled={isLoading}>
                                    {isLoading ? <Loader color="bg-gray-50"/> : "Save"}
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
            <ChangesAlert
                title={"Save Changes"}
                desc={`Are you sure you want to save this changes?`}
                positiveButtonText={"Yes"}
                negativeButtonText={"Cancel"}
                handleDiscardChanges={() => { setModal(false) }}
                handleSaveChanges={saveDetails}
                isOpen={modal} />
        </div>
    );
};

export default ChangePassword;
